// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"23122055","488":"fea86eb7"}[chunkId] + ".chunk.js";
};